<template>
    <v-popover :open.sync="openPopover" @show="onShow">

        <slot></slot>

        <template slot="popover">
            {{ message }}

            <slot name="popover-content"></slot>

            <slot name="popover-actions">
                <div class="mt-3 text-right">
                    <button @click="openPopover = false"
                            class="btn btn-sm btn-link text-info d-inline-block">
                        Cancel
                    </button>
                    <button @click="onConfirm"
                            :disabled="isLoading"
                            class="btn btn-sm btn-outline-primary d-inline-block">
                        {{ confirmBtnText }}
                    </button>
                </div>
            </slot>
        </template>
    </v-popover>
</template>

<script>
export default {
    name: 'AppConfirmationPopover',
    props: {
        action: {
            type: Function,
            required: true
        },
        message: {
            type: String,
            required: true,
            default: 'Confirm action'
        },
        confirmBtnText: {
            type: String,
            default: 'Yes'
        }
    },
    data() {
        return {
            openPopover: false,
            isLoading: false
        }
    },
    methods: {
        async onConfirm() {
            this.isLoading = true
            await this.action()
            this.openPopover = false
            this.isLoading = false
        },

        onShow() {
            this.isLoading = false
        }
    }
}
</script>
